import styles from './ScoreBar.module.css';
import { cn } from '../../lib/cn';

export type LeadScoreClass = 'hot' | 'warm' | 'cold';

interface ScoreBarProps {
  score: number | null;
  klass?: LeadScoreClass | null;
  /** Show the numeric value beside the bar. */
  showValue?: boolean;
}

export function ScoreBar({ score, klass, showValue = true }: ScoreBarProps) {
  if (score === null) {
    return <span className={styles.empty}>—</span>;
  }
  const safe = Math.max(0, Math.min(100, score));
  const tone = klass ?? (safe >= 80 ? 'hot' : safe >= 50 ? 'warm' : 'cold');

  return (
    <span className={styles.wrap}>
      <span
        className={styles.track}
        role="progressbar"
        aria-valuenow={safe}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`ציון ${String(safe)}`}
      >
        <span className={cn(styles.fill, styles[tone])} style={{ inlineSize: `${String(safe)}%` }} />
      </span>
      {showValue ? (
        <span className={styles.value}>
          <span className="num">{String(safe)}</span>
        </span>
      ) : null}
    </span>
  );
}
